import React from 'react'

import { Chip } from '@mui/material'

// The same badge the Features tab gives a boolean, so a flag reads the same on both screens.
const YesNo = ({ value }: { value?: unknown }) => (
  <Chip
    color={value ? 'success' : 'default'}
    label={value ? 'Yes' : 'No'}
    size="small"
    sx={{ fontWeight: 700, letterSpacing: '0.03em', minWidth: 44 }}
  />
)

export default YesNo
